import { createPlugin } from '@backstage/core-plugin-api';

import { WORKFLOW_INSTANCE_RULE_CHANGE_EXTENSION } from './components/WorkflowInstanceRuleChangeExtension';

export const confidenceWorkflowsModuleFlagsPlugin = createPlugin({
  id: 'confidence-workflows-module-flags',
});

export const WorkflowInstanceRuleChangeExtension =
  confidenceWorkflowsModuleFlagsPlugin.provide(
    WORKFLOW_INSTANCE_RULE_CHANGE_EXTENSION,
  );
